import { useState, useEffect } from 'react'
import { Grid } from '@mui/material'

import Dialog from './Dialog'
import AutoComplete from './AutoComplete'
import { useGetAffiliazioniLightQuery } from '../hooks/api-slice'
import { titlesRendiconto } from '../settings/settings'

const DialogRendicontoAdd = ({ open, handleClose, triggerFunction }) => {
  const { data: affiliazioniLight } = useGetAffiliazioniLightQuery()

  const [codiceSocietaAdd, setCodiceSocietaAdd] = useState()

  useEffect(() => {
    setCodiceSocietaAdd()
  }, [open])

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={() => triggerFunction(codiceSocietaAdd)}
      title={titlesRendiconto.titleRendiconto}
      textConfirm='Conferma'
    >
      <Grid container spacing={3} sx={{ width: '100%' }}>
        <Grid size={12}>
          Selezionare una società e cliccare su CONFERMA per creare il
          rendiconto della stagione corrente.
        </Grid>
        <Grid size={12}>
          <center>
            <AutoComplete
              id='codice-societa-add'
              value={codiceSocietaAdd}
              options={affiliazioniLight}
              getOptionLabel={op => {
                const a = affiliazioniLight?.find(
                  a => a?.codiceSocieta === (op?.codiceSocieta || op),
                )
                return `${a?.codiceSocieta} - ${a?.nomeSocieta}`
              }}
              isOptionEqualToValue={(op, value) => op?.codiceSocieta === value}
              label='Società'
              disabled={!affiliazioniLight}
              onChange={i => setCodiceSocietaAdd(i?.codiceSocieta)}
            />
          </center>
        </Grid>
      </Grid>
    </Dialog>
  )
}

export default DialogRendicontoAdd
